import { Component, Input, OnInit, Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { CookieService } from 'ngx-cookie';


@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss']
})

@Injectable()
export class LabelComponent implements OnInit {

  get language() {
    this.storage.retrieve(localStorage.getItem('changedLanguage'));
    return Number(localStorage.getItem('changedLanguage'));
  }

  @Input()
  formItem: any;
  formTitle: string;
  languageId: number = 1;
  scopeLang: any;
  @Input() formId:any;

  constructor(
    private storage: LocalStorageService,
    private cookieService: CookieService
  ) { }


  ngOnInit() {
    this.languageId = Number(this.cookieService.get('formLanguage'));
  }

  getLabel() {
    try {
        let optionFound = this.formItem.item.itemLabels.filter(x => x.language !== null && x.language !== undefined && x.language.idLanguage === this.languageId)[0];
        if (optionFound?.labelField && optionFound.labelField !== '')
          return optionFound.labelField;
        else {
          return this.formItem.item.itemLabels[0].labelField;
        }
    }
    catch (Exception) {
      console.log("ERROR LABELS");
      return '';
    }
  }
}
